import { CustomerInterface } from "../../pages/OrderDetailsPage/OrderDetailsInterface";
import { FiMail, FiPhone } from "react-icons/fi";
import { dictionary } from "../../utils/dictionary";
import { useAuth } from "../../context/AuthContext";

export const CustomerCard = ({ customer }: { customer: CustomerInterface }) => {
  const { language } = useAuth();
  const getInitials = () => {
    const nameParts = `${customer.name} ${customer.last_name}`.split(" ");
    return nameParts
      .map((part) => part.charAt(0))
      .join("")
      .slice(0, 2)
      .toUpperCase();
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow-sm">
      <h2 className="text-lg font-semibold mb-4">{dictionary["customer"][language]}</h2>
      
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-full bg-blue-500 text-white flex items-center justify-center text-sm font-medium">
          {getInitials()}
        </div>
        
        <div className="flex flex-col">
          <h3 className="font-medium text-gray-900">{`${customer.name} ${customer.last_name || ''}`}</h3>
          <p className="text-sm text-gray-500 mb-2">{dictionary["first-time-customer"][language]}</p>
          
          <div className="flex items-center gap-2 text-sm text-gray-600 mt-1">
            <FiMail className="text-gray-400" />
            <span>{customer.email}</span>
          </div>
          
          <div className="flex items-center gap-2 text-sm text-gray-600 mt-1">
            <FiPhone className="text-gray-400" />
            <span>{`${customer?.prefix_phone || ""} ${customer.phone}`}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
